var render, staticRenderFns
import script from "./VuesticTimeline.vue?vue&type=script&lang=js"
export * from "./VuesticTimeline.vue?vue&type=script&lang=js"
import style0 from "./VuesticTimeline.vue?vue&type=style&index=0&id=4b6e52b7&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b6e52b7')) {
      api.createRecord('4b6e52b7', component.options)
    } else {
      api.reload('4b6e52b7', component.options)
    }
    
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-timelines/VuesticTimeline.vue"
export default component.exports